import type { FC } from 'react';
import React from 'react';

import { StickyWrapper } from '../sticky-wrapper';

import type { IStickyProps } from './models';

export const Sticky: FC<IStickyProps> = ({ ReactSticky, children, styles }) => (
    <ReactSticky>{args => StickyWrapper({ ...args, children, styles })}</ReactSticky>
);
